export default __webpack_public_path__ + "static/media/diamond.2fe9e566.svg";